import { useEffect } from "react";
import { CoverEditor } from "./CoverEditor";
import { useSelector } from "react-redux";
import { profileDetails } from "../../../../services/ProfileService";
import useFetch from "../../../../hooks/useFetch";
import { fetchBatchImages } from "../../../../services/mediaService";
import { setCoverImages } from "../../../../redux/slice/sketchSlice";
import { useDispatch } from "react-redux";

const CoverEditorScreen = () => {
  const dispatch = useDispatch();
  const coverImages = useSelector((state) => state.sketch.coverImages);

  const { data: profileData, isLoading: isLoadingProfile } = useFetch({
    dependencies: ["profile"],
    fetchFunction: async () => await profileDetails(),
  });

  const lastBatchId = profileData?.data?.lastBatchDetails?.lastBatchId;
  const { data: batchImagesData, isLoading: isLoadingBatchImages } = useFetch({
    dependencies: ["batchImages", lastBatchId],
    enabled: !!lastBatchId,
    fetchFunction: async () => {
      if (!lastBatchId) return null;
      const result = await fetchBatchImages(lastBatchId);
      return result?.docs?.data || [];
    },
  });

  // Set Redux state from fetched data if empty
  useEffect(() => {
    if (batchImagesData && Array.isArray(batchImagesData) && !!batchImagesData.length) {
      const cover = batchImagesData.filter((img) => img.isCover);

      dispatch(
        setCoverImages(
          cover.map((img) => ({
            ...img,
            resultUrl: img.AIUrl,
            originalUrl: img.url,
            status: "COMPLETED",
            progress: 100,
          }))
        )
      );
    }
  }, [batchImagesData, dispatch]);

  // Guard navigation only if there's truly no data
  if (!coverImages || coverImages.length === 0) {
    if (isLoadingBatchImages || isLoadingProfile) return <div>Loading...</div>;
    return null;
  }

  const coverImage = coverImages[0];

  return <CoverEditor image={coverImage} />;
};

export default CoverEditorScreen;